import React from 'react';

let CategoryBlurb = React.createClass({

  getInitialState: function() {
    return {
      entries: []
    };
  },

  componentDidMount: function() {
    this.setEntries();
  },

  loadEntries: function(cb) {
    let filters = {
      page: 1,
      perpage: 1000,
      sort: 'update_stamp',
      order: 'DESC'
    };

    apiConn.doCall('popularcategorieshandler', 'query', {filters: filters}, (status, data) => {
      if (status) {
        cb(null, data);
      } else {
        cb('failed to load entries', null);
      }
    });
  },

  setEntries: function() {
    this.loadEntries(function(err, res) {
      if (err) {
        console.log('LOAD ERROR', err);
      } else {
        this.setState({
          entries: res.data
        });
      }
    }.bind(this));
  },

  render () {
    const entries = this.state.entries;
    const popularCategories = entries.map((entry, index) => {
      return (
        <div key={index} className="l-grid__item u-width-one-quarter u-padding-a-n portable-u-width-one-half">
          <a href={entry.url} className="category-blurb__img">
            <img className="width-img" src={'/bilder/popular_categories-original/' + entry.id + '/category.jpg'} />
          </a>
        </div>
      );
    });

    return (
      <div className="category-blurb u-text-center">
        {popularCategories.length > 0 ? (
          <div>
            <h1 className="title-large u-margin-t-xl u-margin-b-l u-padding-l-s u-padding-r-s">Populära kategorier</h1>
            <div className="container--alt">
              { popularCategories }
            </div>
          </div>
        ) : false}
      </div>
    );
  }
});

module.exports = CategoryBlurb



// WEBPACK FOOTER //
// ./src/scripts/components/category-blurb.js